import { Injectable } from '@angular/core';

@Injectable()
export class AppSettings {

  API_ENDPOINT: String;
  CONSUMER_KEY: String;
  APPTYPE: String;
  AGGRID_LICENSE: string;

  constructor() {
    this.API_ENDPOINT = 'https://api.somedomain.com/v1/';
    this.CONSUMER_KEY = '';
    this.APPTYPE = '0'; //0)Admin 1)reservation2)wealth management;
    this.AGGRID_LICENSE = "ag-Grid_EvaluationLicense_NotForProduction_100Devs3_May_2017__MTQ5Mzc2NjAwMDAwMA==b836564f7b89ca371343796702a081c1";

  }

}





// WEBPACK FOOTER //
// ./src/app/app.settings.ts